import * as Yup from "yup";
import { APP_CONFIG } from "../../../constants/constants";

// form field names
export type TFormFieldNames = "make" | "model" | "vin" | "license_plate";

// initial values for the form
export const formInitialValues = {
  vehicle_id: "",
  make: "",
  model: "",
  vin: "",
  license_plate: "",
  isactive: 1 as 0 | 1,
  bordercrossing : 0
};

const currentYear = new Date().getFullYear();

// validation schema for the form
export const YupValidationSchema = Yup.object().shape({
  vehicle_id: Yup.string()
    .required("Please enter the asset ID")
    .matches(
      /^[a-z0-9\-_]+$/,
      "Only lowercase characters, numbers, hyphens, and underscores are allowed"
    ),

  // remove all other validations below per client request

  // make: Yup.string()
  //   .required("Please enter the vehicle make"),

  // model: Yup.string()
  //   .required("Please enter the model of the vehicle"),
  // disabled 7/1/2024, as existing database has alphanumeric values
  // .test('len', 'Must be valid year', val => val ? val.toString().length === 4 : false)
  // .max(currentYear, "Vehicle model cannot be in the future"),

  // vin: Yup.string()
  //   .required("Please enter the vehicle VIN")
  //   .matches(
  //     APP_CONFIG.REGEX.VIN,
  //     "Please enter a valid VIN e.g. 1HGBH41JXMN109186"
  //   ),

  // license_plate: Yup.string()
  //   .required("Please enter the vehicle license plate")
  //   .matches(
  //     APP_CONFIG.REGEX.LICENSE_PLATE,
  //     "Please enter a valid license plate"
  //   ),
});
